// The toast staff see after Mark as Sent (#987, #1169). It must match what
// public.notify_customer_quote_sent() and the quote-sent-notify edge function
// actually do, so the checks run in the same order they do.

/**
 * Loose on purpose: it only has to reject placeholders like "n/a" or "none".
 * Same pattern as EMAIL_RE in supabase/functions/quote-sent-notify/index.ts.
 */
export const CLIENT_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** app_settings.quote_sent_customer_email_enabled; "unknown" while it loads or if the read failed. */
export type QuoteSentEmailSwitch = "on" | "off" | "unknown";

/** A missing key reads as off, like the trigger's coalesce(..., 'false'). */
export function emailSwitchFrom(settings: { isSuccess: boolean; data?: Record<string, string> }): QuoteSentEmailSwitch {
  if (!settings.isSuccess) return "unknown";
  return settings.data?.quote_sent_customer_email_enabled === "true" ? "on" : "off";
}

export function markSentSuccessMessage({
  squareSource,
  clientEmail,
  emailSwitch,
}: {
  squareSource: boolean;
  clientEmail: string | null | undefined;
  emailSwitch: QuoteSentEmailSwitch;
}): string {
  if (squareSource) return "Quote marked as sent. Square quotes aren't emailed from here.";
  if (emailSwitch === "off") {
    return "Quote marked as sent. Automatic emails are off, so send the customer the link yourself.";
  }
  const email = (clientEmail ?? "").trim();
  if (!email) return "Quote marked as sent. No client email on file, so the customer was not emailed.";
  if (!CLIENT_EMAIL_RE.test(email)) {
    return "Quote marked as sent. The client email on file doesn't look valid, so the customer was not emailed.";
  }
  if (emailSwitch === "unknown") return "Quote marked as sent.";
  return `Quote sent. We're emailing a link to ${email}.`;
}
